// Liste centralisée des catégories de services
const SERVICE_CATEGORIES = [
  'Municipal',
  'Commercial',
  'Santé',
  'Education',
  'Transport',
  'Loisirs',
  'Autre',
];

export default SERVICE_CATEGORIES;
